<template>
<div class="searchbar-with-button d-flex">
    <input v-if="forZipCode" ref="searchbarInput" :value="inputValue" @input="$emit('update:modelValue', $event.target.value)" type="text" :placeholder="this.options.placeholder" :name="this.options.name" @keyup="valueChanged" @keydown.enter="buttonClicked" @keydown.space="preventSpaces">
    <input v-else-if="forVinNumber" ref="searchbarInput" :value="inputValue" :maxlength="maxLength" @input="$emit('update:modelValue', $event.target.value)" type="text" :placeholder="this.options.placeholder" :name="this.options.name" @keyup="valueChanged" @keydown.enter="buttonClicked" @keydown.space="preventSpaces">
    <input v-else ref="searchbarInput" :value="inputValue" @input="$emit('update:modelValue', $event.target.value)" :maxlength="maxLength" :type="inputType" :placeholder="this.options.placeholder" :name="this.options.name" @keyup="valueChanged" @keydown.enter="buttonClicked" @keydown.space="preventSpaces">
    <button ref="searchbarButton" @click.prevent="buttonClicked">{{ buttonText }}</button>
</div>
</template>

<script>
export default {
    name: "SearchbarWithButton",
    data() {
        return {
            inputValue: ""
        }
    },
    props: {
        modelValue: {
            type: String
        },
        forZipCode: {
            type: Boolean,
            default () {
                return false;
            }
        },
        forVinNumber: {
            type: Boolean,
            default () {
                return false;
            }
        },
        inputType: {
            type: String,
            default () {
                return "text";
            }
        },
        max: {
            type: Number,
        },
        maxLength: Number,
        buttonText: {
            type: String,
            default () {
                return "Go";
            }
        },
        placeholder: {
            type: String,
            default () {
                return "";
            }
        },
        options: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    emits: ['update:modelValue', 'value-changed', 'button-clicked'],
    methods: {
        valueChanged() {
            if (this.forZipCode) {
                this.inputValue = this.inputValue.replace(/\D/g, "");

                if (this.inputValue && this.inputValue.length > 5) {
                    this.inputValue = this.inputValue.substring(0, 5);
                }
            }

            this.$emit("update:modelValue", this.inputValue);
            this.$emit("value-changed", this.inputValue);
        },
        buttonClicked() {
            this.$emit("button-clicked", this.inputValue);
            this.$refs.searchbarInput.blur();
            this.$refs.searchbarButton.blur();
        },
        preventSpaces(event) {
            if (this.options.preventSpaces) {
                event.preventDefault();
            }
        },
    },
    watch: {
        modelValue(newValue) {
            this.inputValue = newValue;
        }
    },
    mounted() {
        this.inputValue = this.modelValue;
    }
}
</script>

<style lang="scss" scoped>
.searchbar-with-button {
    border-radius: 22.5px;

    input {
        border-radius: 22.5px 0 0 22.5px;
        padding: $spacer-three $spacer-four;
        flex-grow: 1;
        flex: 1 1 0;
        min-width: 0;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;
        height:48px;

        &:focus {
            border-color: transparent;
            box-shadow: 0 0 0 5px $blue-thirty;

            +button {
                outline: 0;
            }
        }

        &::placeholder {
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: $grayscale-four;
        }

        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: $grayscale-four;
        }

        &::-ms-input-placeholder {
            /* Microsoft Edge */
            color: $grayscale-four;
        }
    }

    button {
        flex-basis: 110px;
        font-family: $font-family-primary;
        font-weight: $font-weight-semibold;
        line-height: 15px;
        font-size: 16px;
        color: $grayscale-eight;
        background-color: $blue;
        border-radius: 0 100px 100px 0;
        height:48px;

        &:hover {
            background-color: $blue-dark;
            cursor: pointer;
        }

        &:focus {
            box-shadow: 0 0 0 5px $blue-thirty;
            outline: 0;
        }
    }
}

.has-error {

    .searchbar-with-button,
    &.searchbar-with-button {
        border: 1px solid $red;

        input {
            border-color: transparent;

            &:focus {
                box-shadow: 0 0 0 5px $red-thirty;
            }
        }
    }
}
</style>
